import { render, staticRenderFns } from "./StockistTable.vue?vue&type=template&id=01d2d16e&scoped=true&"
import script from "./StockistTable.vue?vue&type=script&lang=js&"
export * from "./StockistTable.vue?vue&type=script&lang=js&"
import style0 from "./StockistTable.vue?vue&type=style&index=0&id=01d2d16e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2d16e",
  null
  
)

export default component.exports